export const updateObject = (oldObject, updatedProperties) => {
    return {
        ...oldObject,
        ...updatedProperties
    }
};


// WEBPACK FOOTER //
// ./src/shared/utility.js